import { SelectV2, SelectV2Option } from '@cimplico/components';
import { useEffect, useState } from 'react';

type DaySelectProps = {
    isDisabled?: boolean;
    selectedMonth?: number;
    title?: string;
    isOptional?: boolean;
    placeholder?: string;
    form?: string;
    errorMessage?: string;
    onChange: (endDay: number[]) => void;
    defaultValue?: number;
    size?: 'small' | 'standard';
};

const thirtyOneDaysMonth = [1, 3, 5, 7, 8, 10, 12];

function calcNumOfDays(month?: number): number[] {
    if (!month) {
        return [];
    }
    if (month === 2) {
        return Array(28)
            .fill(null)
            .map((_, idx) => idx + 1);
    } else if (thirtyOneDaysMonth.includes(month)) {
        return Array(31)
            .fill(null)
            .map((_, idx) => idx + 1);
    }
    return Array(30)
        .fill(null)
        .map((_, idx) => idx + 1);
}

function DaySelect({
    isDisabled,
    selectedMonth,
    title,
    isOptional = false,
    placeholder,
    form,
    errorMessage,
    defaultValue,
    onChange,
    size = 'standard',
}: DaySelectProps): JSX.Element {
    const [selected, setSelected] = useState<SelectV2Option[]>([]);
    const [search, setSearch] = useState('');

    const [currentMonth, setCurrentMonth] = useState<{ month?: number; days: number[] }>({
        month: selectedMonth,
        days: calcNumOfDays(selectedMonth),
    });

    function handleEndDayChange(options: SelectV2Option[]): void {
        onChange(options.map((o) => o.value as number));
    }

    useEffect(() => {
        setCurrentMonth({ month: selectedMonth, days: calcNumOfDays(selectedMonth) });
        setSelected([]);
    }, [selectedMonth]);

    useEffect(() => {
        setSelected(defaultValue ? [{ label: `${defaultValue}`, value: defaultValue }] : []);
    }, [defaultValue]);

    return (
        <div>
            <SelectV2
                keepSelectedOptions
                key={`month-${selectedMonth}`}
                placeholder={placeholder || 'Select a day...'}
                title={title}
                form={form}
                isOptional={isOptional}
                disabled={isDisabled}
                size={size}
                errorMessage={errorMessage}
                value={selected}
                onSearch={setSearch}
                onChange={handleEndDayChange}
                options={currentMonth.days.filter((day) => day.toString().includes(search)).map((d) => ({ label: `${d}`, value: d }))}
            />
        </div>
    );
}
export default DaySelect;
